import React from "react";
import { Form, Input, Button, Upload, message, Spin } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { createAmenity } from "../../features/amenitySlice";
import App from "../../Utils/LayoutMobile";
import { useNavigate } from "react-router-dom";

const CreateAmenity = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.amenities);

  const handleSubmit = (values) => {
    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("description", values.description || "");
    if (values.icon && values.icon[0]?.originFileObj) {
      formData.append("icon", values.icon[0].originFileObj);
    }

    dispatch(createAmenity(formData))
      .unwrap()
      .then(() => {
        message.success("Amenity created successfully");
        form.resetFields();
        navigate("/Amenity");
      })
      .catch((error) => {
        message.error(error || "Failed to create amenity");
      });
  };

  return (
    <App>
      <Spin spinning={loading}>
        <h2 style={{ marginBottom: 24 }}>Add New Amenity</h2> {/* 👈 Label */}
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
          style={{ maxWidth: 500 }}
        >
          <Form.Item
            name="name"
            label="Amenity Name"
            rules={[{ required: true, message: "Please enter amenity name" }]}
          >
            <Input placeholder="Enter amenity name" />
          </Form.Item>

          <Form.Item name="description" label="Description">
            <Input.TextArea
              rows={3}
              placeholder="Enter description (optional)"
            />
          </Form.Item>

          <Form.Item
            name="icon"
            label="Icon Image"
            valuePropName="fileList"
            getValueFromEvent={(e) => e?.fileList}
          >
            <Upload beforeUpload={() => false} maxCount={1} listType="picture">
              <Button icon={<UploadOutlined />}>Upload Icon</Button>
            </Upload>
          </Form.Item>

          <Form.Item style={{ textAlign: "right" }}>
            <Button
              style={{ marginRight: 8 }}
              onClick={() => navigate("/Amenity")}
            >
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              Add Amenity
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </App>
  );
};

export default CreateAmenity;
